import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { IconComponent } from '../Icons/IconComponent';
import { AnimatedTextView } from './AnimatedTextView';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
export const TextRowView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.textRow,
    style: {
        container: {
            flex: 1,
            flexDirection: 'row',
            alignItems: 'center'
        },
        textContainer: {
            flexShrink: 1
        },
        text: {
            fontSize: 15,
            lineHeight: 20
        }
    }
})(({ style, containerStyle, icon, iconColor, iconSize, textStyle, value }) => {
    return (_jsxs(View, { style: [style === null || style === void 0 ? void 0 : style.container, containerStyle], children: [!!icon && (_jsx(IconComponent, { name: icon, size: iconSize || 16, color: iconColor })), _jsx(View, { style: [style === null || style === void 0 ? void 0 : style.textContainer, { paddingStart: icon ? 11 : 0 }], children: _jsx(AnimatedTextView, { textStyle: [style === null || style === void 0 ? void 0 : style.text, textStyle], children: value }) })] }));
});
